import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LandingPage from "@/pages/LandingPage";
import AuthCallback from "@/pages/AuthCallback";
import PulsePage from "@/pages/PulsePage";
import SettingsPage from "@/pages/SettingsPage";
import PublicStatusPage from "@/pages/PublicStatusPage";
import AdminPage from "@/pages/AdminPage";

// CRITICAL: send cookies on all axios requests
axios.defaults.withCredentials = true;

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white/60 text-sm">
        Verificando sesión...
      </div>
    );
  }
  if (!user && !location.state?.user) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const AppRouter = () => {
  const location = useLocation();
  // Synchronous detection of OAuth callback to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/s/:token" element={<PublicStatusPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <PulsePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#121216",
            color: "#FFFFFF",
            border: "1px solid #00E5FF",
            fontFamily: "'IBM Plex Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
